const Emoji_A = {
    ':ablow': { id: 76, width: 30, height: 25 },
    ':admin': { id: 77, width: 30, height: 22 },
    ':afro': { id: 79, width: 33, height: 31 },
    ':afro2': { id: 78, width: 27, height: 27 },
    ':agasi': { id: 80, width: 27, height: 22 },
    ':aggressive': { id: 81, width: 36, height: 27 },
    ':airquot': { id: 593, width: 35, height: 17 },
    ':ala': { id: 82, width: 20, height: 22 },
    ':alien': { id: 45, width: 18, height: 18 },
    ':alien2': { id: 83, width: 26, height: 22 },
    ':alucard': { id: 85, width: 38, height: 24 },
    ':angel_hypocrite': { id: 87, width: 20, height: 25 },
    ':angel_innocent': { id: 88, width: 18, height: 22 },
    ':angel_not': { id: 89, width: 18, height: 24 },
    ':angel': { id: 86, width: 42, height: 23 },
    ':angrier': { id: 90, width: 18, height: 18 },
    ':angry': { id: 92, width: 20, height: 20 },
    ':angry2': { id: 91, width: 18, height: 18 },
    ':angst': { id: 93, width: 16, height: 16 },
    ':animal_rooster': { id: 94, width: 18, height: 23 },
    ':animals_bunny1': { id: 95, width: 18, height: 24 },
    ':animals_bunny2': { id: 96, width: 18, height: 29 },
    ':appl': { id: 97, width: 35, height: 31 },
    ':arabia': { id: 98, width: 21, height: 28 },
    ':argue3': { id: 99, width: 43, height: 18 },
    ':arrow_1': { id: 100, width: 20, height: 20 },
    ':arrow_2': { id: 101, width: 20, height: 20 },
    ':arrow_3': { id: 102, width: 20, height: 20 },
    ':arrow_4': { id: 103, width: 20, height: 20 },
    ':arrow_5': { id: 104, width: 20, height: 20 },
    ':arrow_6': { id: 105, width: 20, height: 20 },
    ':arrow': { id: 48, width: 18, height: 18 },
}

export default Emoji_A
